import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const accountsPath = `${BASE_PATH_API}/glAccounts`;

const actions = {
    getCharges: {
        type: 'GET',
        url: `${accountsPath}/charges`,
        isArray: true
    },
    getAccounts: {
        type: 'GET',
        url: `${accountsPath}/all`
    },
    getGroupedAccounts: {
        method: 'GET',
        url: `${accountsPath}/grouped`
    },
    getCredits: {
        type: 'GET',
        isArray: true,
        url: `${accountsPath}/credits`
    },
    getReversePayments: {
        type: 'GET',
        isArray: true,
        url: `${accountsPath}/reversePayments`
    },
    query: {
        method: 'GET',
        url: accountsPath
    },
    queryCached: {
        method: 'GET',
        url: accountsPath,
        cache: true
    },
    save: {
        method: 'POST',
        url: accountsPath
    },
    create: {
        method: 'POST',
        url: accountsPath
    },
    update: {
        method: 'PUT',
        url: `${accountsPath}/:id`
    },
    delete: {
        method: 'DELETE',
        url: `${accountsPath}/:id`
    },
    getIncomeAccounts: {
        method: 'GET',
        url: `${accountsPath}/income`,
        isArray: true
    },
    cancelPendingAction: {
        method: 'POST',
        url: `${BASE_PATH_API}/glAccounts/:id/cancelrequest`
    },
    getGroupedHierarchicalAccounts: {
        method: 'GET',
        url: `${accountsPath}/grouped/hierarchical`
    },
    getGLAccountsOfRecurringCharges: {
        method: 'GET',
        url: `${BASE_PATH_API}/recurringcharges/:leaseId/GLAccountsOfRecurringCharges`
    },
    getManageChartOfAccountDetails: {
        method: 'GET',
        url: `${BASE_PATH_API}/glAccounts/:glAccountId/usedDetails`
    },
    changeManageChartOfAccountDetails: {
        method: 'POST',
        url: `${BASE_PATH_API}/glAccounts/manageChartOfAccounts`
    },
    getGlAccountsByType: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/glAccounts`
    },
    getDisplayAccountNumbers: {
        method: 'GET',
        url: `${BASE_PATH_API}/glAccounts/displayAccountNumbers`
    },
    setDisplayAccountNumbers: {
        method: 'PUT',
        url: `${BASE_PATH_API}/glAccounts/displayAccountNumbers/:display`
    },
    inactivate: {
        method: 'POST',
        url: `${accountsPath}/inactivate`
    },
    isGLAccountToInactivateBeingUsed: {
        method: 'GET',
        url: `${accountsPath}/inactivate/:glAccountId/usedDetails`
    },
    reactivate: {
        method: 'POST',
        url: `${accountsPath}/reactivate`
    },
    getAccountWithFundTypeExists: {
        method: 'GET',
        url: `${accountsPath}/fundType/:typeId`
    }
};

export function GLAccountsApi() {
    return createActions(actions);
}
